import "./style.css";

import React, { useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import dataContext from "../../../context/dataContext";
import mainContext from "../../../context/mainContext";

import StartFooter from "../../../components/Common/StartFooter";

import Headphone from "../../../assets/images/illustrations/head-phones.svg";
import FrameIcon from "../../../assets/images/icons/FrameHeadPhone.png";

// Can be FrameConus // FramePencil // FrameCamera // FrameHeadPhone

const LevelExercise = () => {
  const user = useContext(dataContext);
  const { state: { navigateObject } } = useLocation()
  const BookName = navigateObject.bookName;
  console.log("🚀 ~ file: index.jsx:19 ~ LevelExercise ~ navigateObject:", navigateObject)
  const navigate = useNavigate();
  const { header } = useContext(mainContext);

  useEffect(() => {
    header.setPageName("FINE-TUNING INSTRUCTION");
    return () => header.setPageName("");
  }, [])

  const lpmFromPushup = 20;
  const title = "CONTINUE";
  const textTitle = "Now,";
  const text = `let's make sure we got your current speed right, continue reading while slightly adjusting the speed faster or slower until its just right.`;
  const route = "/train-reading/exercise-clock";
  const objProps = {
    fromPath: "train-reading/exercise",
    from: "pushup"
    // Add all the answers from pushup questions
  };


  // TODO need to order the names from the start
  const formatedObj = {
    ...objProps,
    ...navigateObject,
    lpm: Math.round(navigateObject.rateData.LPM),
    chosenLpm: Math.round(navigateObject.rateData.LPM)
  }

  const startFunction = () => navigate(route, { state: formatedObj });

  return (
    <>
      <div className="level_exercise">
        <img src={Headphone} alt="Headphone" />
      </div>
      <StartFooter
        title={title}
        subtitle={textTitle}
        explanation={text}
        startFunction={startFunction}
        img={FrameIcon}
      />
    </>
  );
};

export default LevelExercise;
